export default __webpack_public_path__ + "static/media/laughingHeads.399858dd.png";